import { Navigate, Route, Routes } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import AgentHub from './pages/AgentHub';
import AgentDetailPage from './pages/AgentDetailPage';
import CreateAgentPage from './pages/CreateAgentPage';
import ObservePage from './pages/ObservePage';
import EcosystemPage from './pages/EcosystemPage';
import StepsPage from './pages/StepsPage';
import ConversationalCreator from './custodian/ConversationalCreator';
import KnowledgeBase from './custodian/KnowledgeBase';
import WorkflowDesignerPage from './volcano/pages/WorkflowDesignerPage';

export default function AgentManagerRouter() {
  return (
    <Routes>
      {/* Tab 1: Agents — unified list */}
      <Route path="hub" element={<AgentHub />} />
      <Route path="hub/:agentId" element={<AgentDetailPage />} />

      {/* Tab 2: Create — Custodian front and center */}
      <Route path="create" element={<CreateAgentPage />} />
      <Route path="create/custodian" element={<ConversationalCreator />} />
      <Route path="create/custodian/:conversationId" element={<ConversationalCreator />} />
      <Route path="create/knowledge" element={<KnowledgeBase />} />

      {/* Tab 3: Observe — executions, costs, audit */}
      <Route path="observe" element={<ObservePage />} />

      {/* Tab 4: Ecosystem — dependency graph + tools map */}
      <Route
        path="ecosystem"
        element={
          <ReactFlowProvider>
            <EcosystemPage />
          </ReactFlowProvider>
        }
      />

      {/* Tab 5: Steps — Volcano step library */}
      <Route path="steps" element={<StepsPage />} />

      {/* Volcano Workflow Designer (Expert Mode) */}
      <Route path="volcano/:agentId/edit" element={<WorkflowDesignerPage />} />

      {/* Default to hub */}
      <Route index element={<Navigate to="hub" replace />} />
      <Route path="*" element={<Navigate to="hub" replace />} />
    </Routes>
  );
}
